/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Add_Voices_LabelInputs */



/**
* | output |
* | --- |
* | "Add Voices" |
*
* @param {Voices_Add_Voices_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_add_voices_label = /** @type {((inputs?: Voices_Add_Voices_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Add_Voices_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des voix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stimmen hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi voci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить голоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar voces")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加声音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声を追加する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाजें जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar vozes")
	return /** @type {LocalizedString} */ ("Add Voices")
});